import { render, staticRenderFns } from "./ServiceProviderProfile.vue?vue&type=template&id=a5b65df6"
import script from "./ServiceProviderProfile.vue?vue&type=script&lang=js"
export * from "./ServiceProviderProfile.vue?vue&type=script&lang=js"
import style0 from "./ServiceProviderProfile.vue?vue&type=style&index=0&id=a5b65df6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports